<div class="d-flex flex-row justify-content-end">
        <input
            #hourInput
            [disabled]="disabled"
            class="hour-input {{ getColorClass() }} text-end form-control form-control-sm"
            [class.w-75]="!compact"
            [class.hour-input--compact]="compact"
            [class.hour-input--zero]="compact && timer === 0 && !kode"
            [attr.aria-label]="label"
            [value]="compact && timer == null ? '' : (timer | time)"
            [placeholder]="compact ? '—' : ''"
            (keydown.enter)="compact && hourInput.blur()"
            type="text"
            (focus)="hourInput.select()"
            (change)="onChangeTimer(hourInput.value)"
        />
</div>
